import { useState, useLayoutEffect, useCallback } from "react";

function clamp(number, min, max) {
    return Math.min(Math.max(number, min), max);
}

export default function useScroll(startY, height) {
    const [scroll, setScroll] = useState([0, 0]);

    const onScroll = useCallback(() => {
        const nextHeight = clamp((1 - (document.documentElement.scrollTop - startY) / 126) * 126, 61, 126);

        if (height !== nextHeight) {
            setScroll([document.documentElement.scrollTop, document.documentElement.scrollLeft]);
        }
    }, [startY, height]);

    useLayoutEffect(() => {
        if (window) {
            window.addEventListener("scroll", onScroll);
            onScroll();
            
            return () => {
                if (window) {
                    window.removeEventListener("scroll", onScroll);
                }
            };
        }
    }, [onScroll]);

    return scroll;
}